import {
    BanknotesIcon,
    AtSymbolIcon, ChatBubbleLeftRightIcon, DocumentIcon, DocumentTextIcon, IdentificationIcon,
    LinkIcon,
    MapPinIcon,
    PhoneIcon,
    ShoppingCartIcon,
    WifiIcon, PhotoIcon,
    PaperAirplaneIcon,
    ChatBubbleBottomCenterIcon
} from "@heroicons/vue/24/outline";

export default [
    { type: 'link', title: 'Ссылка', description: 'Ссылка на уже существующий сайт', supportFor: ['dynamic', 'static'], checked: false, icon: LinkIcon  },
    { type: 'geolocation', title: 'Geo локация', description: 'Открыть карту с переданными координатами на карте', supportFor: ['dynamic', 'static'], checked: false, icon: MapPinIcon },
    { type: 'email', title: 'Email', description: 'Отправить письмо на переданную электронную почту', supportFor: ['dynamic', 'static'], checked: false, icon: AtSymbolIcon },
    { type: 'call', title: 'Телефон', description: 'Позвонить по переданному номеру телефона', supportFor: ['dynamic', 'static'], checked: false, icon: PhoneIcon },
    { type: 'sms', title: 'Sms', description: 'Отправить смс с определенном текстом на переданный номер', supportFor: ['dynamic', 'static'], checked: false, icon: ChatBubbleLeftRightIcon },
    // { type: 'image', title: 'Картинка', description: 'Ссылка или загруженная картинка', supportFor: ['dynamic'], checked: false, icon: PhotoIcon },
    // { type: 'messenger', title: 'Сообщение в мессенджер', description: 'Сообщение в установленный на телефоне мессенджер: телеграм или whatsapp', supportFor: ['dynamic', 'static'], checked: false, icon: ChatBubbleBottomCenterIcon },
    { type: 'pdf', title: 'PDF документ', description: 'Открыть PDF докумен', supportFor: ['dynamic', 'static'], checked: false, icon: DocumentIcon },
    { type: 'vcard', title: 'Контакт', description: 'Передать контактные данные', supportFor: ['dynamic', 'static'], checked: false, icon: IdentificationIcon },
    { type: 'text', title: 'Текст', description: 'Показать простой текст', supportFor: ['static'], checked: false, icon: DocumentTextIcon },
    { type: 'linktoapp', title: 'Ссылка на приложение', description: 'Ссылка на загрузку вашего приложения', supportFor: ['dynamic'], checked: false, icon: ShoppingCartIcon },
    { type: 'totelegram', title: 'Отправить сообщение в telegram', description: 'Отправить сообщение в telegram', supportFor: ['dynamic'], checked: false, icon: PaperAirplaneIcon },
    { type: 'towhatsapp', title: 'Отправить сообщение в whatsapp', description: 'Отправить сообщение в whatsapp', supportFor: ['dynamic'], checked: false, icon: ChatBubbleBottomCenterIcon },
]

export const validationRules = {
    link: {
        link: value => value?.length > 0 || 'Поле ссылки не может быть пустым'
    },
    geolocation: {
        latitude: value => value?.toString().length > 0 || 'Поле широты не может быть пустым',
        longitude: value => value?.toString().length > 0 || 'Поле долготы не может быть пустым'
    },
    email: {
        email: value => value?.length > 0 || 'Поле email не может быть пустым'
    },
    call: {
        phone: value => value?.length > 0 || 'Поле телефона не может быть пустым'
    },
    sms: {
        phone: value => value?.length > 0 || 'Поле телефона не может быть пустым',
        body: value => value?.length > 0 || 'Поле сообщения не может быть пустым'
    },
    pdf: {
        fileId: value => value?.length > 0 || 'Нужно загрузить файл'
    },
    vcard: {
        phone: value => value?.length > 0 || 'Нужно заполнить поле телефон'
    },
    text: {
        text: value => value?.length > 0 || 'Текстовое поле не может быть пустым'
    },
    linktoapp: {
        apple: value => value?.length > 0 || 'Добавьте ссылку на приложение в apple store',
        google: value => value?.length > 0 || 'Добавьте ссылку на приложение в google play'
    },
    totelegram: {
        phone: value => value?.length > 0 || 'Поле телефона не может быть пустым',
        body: value => value?.length > 0 || 'Поле сообщения не может быть пустым'
    },
    towhatsapp: {
        phone: value => value?.length > 0 || 'Поле телефона не может быть пустым',
        body: value => value?.length > 0 || 'Поле сообщения не может быть пустым'
    }
};
